module.exports = __webpack_public_path__ + "568e955c192febe23e19453fa2b13aa6.svg";